/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { enableWhyDidYouRender } from './project-config.json';

import { PricingBenefitsPage, RewardsHubPage, PerksPage } from './src/pages';
import {
  AvailablePerksProvider,
  InfoOffersProvider,
  InfoPerksProvider,
  NationalAccountProvider,
  PerksRedeemProvider,
  RewardsAndOffersProvider,
  PerkProgressProvider,
  LegacyTiersProvider,
  RewardsHubProvider,
  AvailablePerksContext,
  InfoOffersContext,
  InfoPerksContext,
  NationalAccountContext,
  PerksRedeemContext,
  RewardsAndOffersContext,
  PerkProgressContext,
  LegacyTiersContext,
  RewardsHubContext,
} from './src/contexts';
import {
  PricingBenefitsContainer,
  PerksPageContainer,
  RewardsHubContainer,
} from './src/containers';

const addWdyrToComponents = () => {
  [
    // Pages
    PricingBenefitsPage,
    PerksPage,
    RewardsHubPage,

    // Contexts
    AvailablePerksProvider,
    InfoOffersProvider,
    InfoPerksProvider,
    NationalAccountProvider,
    PerksRedeemProvider,
    RewardsAndOffersProvider,
    PerkProgressProvider,
    LegacyTiersProvider,
    RewardsHubProvider,
    AvailablePerksContext,
    InfoOffersContext,
    InfoPerksContext,
    NationalAccountContext,
    PerksRedeemContext,
    RewardsAndOffersContext,
    PerkProgressContext,
    LegacyTiersContext,
    RewardsHubContext,

    // Containers
    PricingBenefitsContainer,
    PerksPageContainer,
    RewardsHubContainer,

    // Component-specific
    //
    //
  ].forEach((ele) => {
    // eslint-disable-next-line no-param-reassign
    ele.whyDidYouRender = true;
  });
};

const whyDidYouRender = {
  init: () => {
    // const isEnabled = true;
    const isEnabled =
      process.env.NODE_ENV === 'development' && enableWhyDidYouRender;
    if (isEnabled) {
      addWdyrToComponents();
      // eslint-disable-next-line global-require
      const render = require('@welldone-software/why-did-you-render');
      render(React, {
        logOnDifferentValues: false,
        // trackAllPureComponents: true, // Use this to track React.PureComponent or React.memo components
        // include: [/^/], // Use this to track all components
      });
    }
  },
};
export { whyDidYouRender };
